export const HASURA_CLAIMS_NAMESPACE = 'https://hasura.io/jwt/claims';

export const USER_ROLE = 'user';

export const SUPER_USER_ROLE = 'super_user';

export const HASURA_ROLES = [USER_ROLE, SUPER_USER_ROLE] as const;

export type HasuraRole = (typeof HASURA_ROLES)[number];

export const ORG_ROLES = ['member', 'admin', 'owner'] as const;

export type OrgRole = (typeof ORG_ROLES)[number];

export type HasuraClaims = {
  'x-hasura-allowed-roles': HasuraRole[];
  'x-hasura-default-role': HasuraRole;
  'x-hasura-user-id': string;
};

export type AuthClaims = {
  sub: string;
  [HASURA_CLAIMS_NAMESPACE]: HasuraClaims;
};

const ORG_ROLE_RANK: Record<OrgRole, number> = { owner: 3, admin: 2, member: 1 };

export function orgRoleSatisfies(role: OrgRole, required: OrgRole) {
  return ORG_ROLE_RANK[role] >= ORG_ROLE_RANK[required];
}

export function allowedHasuraRoles(isSuperUser: boolean) {
  return isSuperUser ? [USER_ROLE, SUPER_USER_ROLE] : [USER_ROLE];
}

export function claimsAreSuperUser(claims: AuthClaims) {
  return claims[HASURA_CLAIMS_NAMESPACE]['x-hasura-allowed-roles'].includes(SUPER_USER_ROLE);
}
